let appWrapper = document.querySelector('#app'),
    scrollElement = document.scrollingElement || document.documentElement,
    scrollFromTop = scrollElement.scrollTop,
    navbar = document.querySelector('.navbar'),
    mainNav = document.querySelector('.main-menu'),
    mainNavTrigger = document.querySelector('.main-menu-trigger'),
    mainNavInTransition = false,
    quantityControlIncrement = document.querySelector('.btn-control.increment'),
    quantityControlDecrement = document.querySelector('.btn-control.decrement'),
    scrollClass = 'is-scrolling',
    activeClass = 'is-active',
    menuDropdownInTransition = false,
    menuDropdown = document.querySelector('.nav-item.dropdown'),
    menuDropdownIndicator = document.querySelector('.nav-item.dropdown .indicator'),
    menuDropdownItems = document.querySelector('.nav-item.dropdown .items'),
    langDropdownInTransition = false,
    langTrigger = document.querySelector('.multiple-dropdowns .dropdown.lang-trigger .btn'),
    langTriggerEl = document.querySelector('.multiple-dropdowns .dropdown.lang-trigger'),
    langDropdown = document.querySelector('.multiple-dropdowns .dropdown.lang-trigger .dropdown-list'),
    currencyDropdownInTransition = false,
    currencyTrigger = document.querySelector('.multiple-dropdowns .dropdown.currency-trigger .btn'),
    currencyTriggerEl = document.querySelector('.multiple-dropdowns .dropdown.currency-trigger'),
    currencyDropdown = document.querySelector('.multiple-dropdowns .dropdown.currency-trigger .dropdown-list'),
    langDTrigger = document.querySelector('.dropdown.lang-trigger .btn'),
    langDTriggerEl = document.querySelector('.dropdown.lang-trigger'),
    langDTriggerDropdown = document.querySelector('.dropdown.lang-trigger .dropdown-list'),
    currencyDTrigger = document.querySelector('.dropdown.currency-trigger .btn'),
    currencyDTriggerEl = document.querySelector('.dropdown.currency-trigger'),
    currencyDTriggerDropdown = document.querySelector('.dropdown.currency-trigger .dropdown-list'),
    newsletter = $("#newsletter-modal"),
    infoModal = $("#info-modal")

if (scrollFromTop > 0) {
    if (navbar) {
        appWrapper.classList.add(scrollClass)
    }
}

window.onscroll = function () {
    let el = document.scrollingElement || document.documentElement
    let scrollPosition = el.scrollTop

    if (navbar) {
        if (scrollPosition > 0 && ! appWrapper.classList.contains(scrollClass)) {
            appWrapper.classList.add(scrollClass)
        } else if (scrollPosition == 0 && appWrapper.classList.contains(scrollClass)) {
            appWrapper.classList.remove(scrollClass)
        }
    }
}

$(window).scroll(function() {
    // if (getCurrentScroll() > 100 && getCookie("newsletter_shown") != 1) {
    //   showNewsletter();
    // }

    if (getCurrentScroll() > 100 && getCookie("info_shown_daily") != 1) {
      showInfoModal();
    }
});

$("body").on("click", "#close-newsletter", hideNewsletter);
$("body").on("click", "#close-info", hideInfoModal);

$("body").on("submit", "#newsletter-form", function() {
    setCookie("newsletter_shown", 1, 90);
    hideNewsletter();
});

function setCookie(name, value, durationDays) {
    var d = new Date();
    d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function setCookieHours(name, value, durationHours) {
    var d = new Date();
    d.setTime(d.getTime() + durationHours * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(cookie) {
    var name = cookie + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}

function showNewsletter() {
    newsletter.addClass("show-flex");

    setCookie("newsletter_shown", 1, 2);
}

function hideNewsletter() {
    newsletter.removeClass("show-flex");
}

function showInfoModal() {
    infoModal.addClass("show-flex");

    setCookieHours("info_shown_daily", 1, 1);
}

function hideInfoModal() {
    infoModal.removeClass("show-flex");
}

function handleNavTransitionEvent(e) {
    mainNavInTransition = false
}

function handleMenuTransitionEvent(e) {
    menuDropdownInTransition = false
}

function handleLangTransitionEvent(e) {
    langDropdownInTransition = false
}

function handleCurrencyTransitionEvent(e) {
    currencyDropdownInTransition = false
}

if (mainNavTrigger) {
    mainNavTrigger.onclick = function () {
        if (mainNavInTransition === false) {
            mainNavInTransition = true

            if (! mainNav.classList.contains(activeClass)) {
                mainNav.classList.add(activeClass)
                mainNavTrigger.classList.add(activeClass)
                document.querySelector('body').style.overflow = "hidden"

                mainNav.addEventListener('transitionend', handleNavTransitionEvent, false)
            } else {
                mainNav.classList.remove(activeClass)
                mainNavTrigger.classList.remove(activeClass)
                document.querySelector('body').style.overflow = null

                mainNav.addEventListener('transitionend', handleNavTransitionEvent, false)
            }
        }
    }
}

if (menuDropdown) {
    menuDropdown.onclick = function () {
        if (menuDropdownInTransition === false) {
            menuDropdownInTransition = true

            if (! menuDropdown.classList.contains(activeClass)) {
                menuDropdown.classList.add(activeClass)
                menuDropdownIndicator.innerHTML = '-'

                menuDropdownItems.addEventListener('transitionend', handleMenuTransitionEvent, false)
            } else {
                menuDropdown.classList.remove(activeClass)
                menuDropdownIndicator.innerHTML = '+'

                menuDropdownItems.addEventListener('transitionend', handleMenuTransitionEvent, false)
            }
        }
    }
}

if (langTrigger) {
    langTrigger.onclick = function () {
        if (langDropdownInTransition === false) {
            langDropdownInTransition = true

            if (! langDropdown.classList.contains(activeClass)) {
                langDropdown.classList.add(activeClass)
                langTriggerEl.classList.add(activeClass)
                // menuDropdownIndicator.innerHTML = '-'

                langDropdown.addEventListener('transitionend', handleLangTransitionEvent, false)
            } else {
                langDropdown.classList.remove(activeClass)
                langTriggerEl.classList.remove(activeClass)
                // menuDropdownIndicator.innerHTML = '+'

                langDropdown.addEventListener('transitionend', handleLangTransitionEvent, false)
            }
        }
    }
}

if (currencyTrigger) {
    currencyTrigger.onclick = function () {
        if (currencyDropdownInTransition === false) {
            currencyDropdownInTransition = true

            if (! currencyDropdown.classList.contains(activeClass)) {
                currencyDropdown.classList.add(activeClass)
                currencyTriggerEl.classList.add(activeClass)

                currencyDropdown.addEventListener('transitionend', handleCurrencyTransitionEvent, false)
            } else {
                currencyDropdown.classList.remove(activeClass)
                currencyTriggerEl.classList.remove(activeClass)

                currencyDropdown.addEventListener('transitionend', handleCurrencyTransitionEvent, false)
            }
        }
    }
}

if (langDTrigger) {
    langDTrigger.onclick = function () {
        if (langDropdownInTransition === false) {
            langDropdownInTransition = true

            if (! langDTriggerEl.classList.contains(activeClass)) {
                langDTriggerEl.classList.add(activeClass)

                langDTriggerDropdown.addEventListener('transitionend', handleLangTransitionEvent, false)
            } else {
                langDTriggerEl.classList.remove(activeClass)

                langDTriggerDropdown.addEventListener('transitionend', handleLangTransitionEvent, false)
            }
        }
    }
}

if (currencyDTrigger) {
    currencyDTrigger.onclick = function () {
        if (currencyDropdownInTransition === false) {
            currencyDropdownInTransition = true

            if (! currencyDTriggerEl.classList.contains(activeClass)) {
                currencyDTriggerEl.classList.add(activeClass)

                currencyDTriggerDropdown.addEventListener('transitionend', handleCurrencyTransitionEvent, false)
            } else {
                currencyDTriggerEl.classList.remove(activeClass)

                currencyDTriggerDropdown.addEventListener('transitionend', handleCurrencyTransitionEvent, false)
            }
        }
    }
}


if (quantityControlIncrement && quantityControlDecrement) {
    let quantityOfProduct = document.querySelector('input[name="quantity"]')

    quantityControlIncrement.onclick = function () {
        incrementValue(quantityOfProduct)
    }

    quantityControlDecrement.onclick = function () {
        decrementValue(quantityOfProduct)
    }
}

$('body').on('click', '.gift button', function () {
    let giftField = $('.gift select'),
    selected = giftField.val()

    if (selected == null) {
        return false
    }

    if (selected == 'none') {
        $('.gift').hide()
        return true
    }

    $.post('/index.php?route=checkout/confirm/addGift', { product_id: selected }, function (response) {
        $('.gift').hide()

        // Check if successful and add a row to the cart list
        console.log(response)

        $('#collapse-checkout-confirm').html(response.content)
    })
})

if ($('.card').length > 0) {
    $(".card").on("hidden.bs.collapse", function() {
        $(this).removeClass("active");
    });

    $(".card").on("shown.bs.collapse", function() {
        $(this).addClass("active");
    });
}

function decrementValue(valueField) {
    let currentValue = parseInt(valueField.value)

    if (isNaN(currentValue)) {
        currentValue = 1
    }

    if (currentValue <= 1) {
        currentValue = 1
        return
    }

    valueField.value = currentValue - 1
}

function incrementValue(valueField) {
    let currentValue = parseInt(valueField.value)

    if (isNaN(currentValue)) {
        currentValue = 0
    }

    if (currentValue < 1) {
        currentValue = 0
    }

    valueField.value = currentValue + 1
    return
}

$(function () {
    $('[data-toggle="popover"]').popover()
})

$(document).ready(function() {
    $('#drink').select2({
        minimumResultsForSearch: -1,
    });
});
